<template>
  <div class="main">
    <el-header style="padding: 0" height="120px">
      <systemHeader />
    </el-header>
    <el-main class="mian_bottom" style="padding: 0">
      <transition name="fade-transform" mode="out-in">
        <router-view />
      </transition>
    </el-main>
  </div>
</template>

<script>
import systemHeader from '@/components/SystemHeader.vue'

export default {
  components: { systemHeader },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
.mian_bottom {
  height: calc(100vh - 8.53333rem) !important;
  max-height: 69.33333rem;
}
.mian_bottom::-webkit-scrollbar {
  display: none;
}
</style>
